var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageSave = function SvgImageSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4 24.7v3.2h20.8v-3.2zM8.3 0h4v8.1h-4zM0 0h5.3v9.8h20.9V0h5.5v32H0z"
  })));
};
export { SvgImageSave as ReactComponent };
export default __webpack_public_path__ + "assets/ImageSave.a8de801161a0009bba8f263234448888.svg";